import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ProcessingDialogData {
  title?: string;
  message?: string;
  total?: number;
}

@Component({
  selector: 'app-processing-dialog',
  templateUrl: './processing-dialog.component.html',
  styleUrls: ['./processing-dialog.component.css']
})
export class ProcessingDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ProcessingDialogData) {}
}
